import { Box, Stack } from '@mui/material';
import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';

import { VenuePreset } from '@/domain/project-venue-presets/entities/project-venue-presets.entity.ts';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSTextField } from '@/ui/components/input/FSTextField';
import { translate } from '@/ui/i18n';
import { DefaultDatasContext } from '@/ui/pages/app/project/venue/default-datas/default-datas-quiz-panel/DefaultDatasContext';
import {
  QuizEdition,
  QuizNotEdition,
} from '@/ui/pages/app/project/venue/default-datas/default-datas-quiz-panel/DefaultDatasQuizComponents';
import { isNumber } from '@/ui/utils/form-validations';

export function AverageCapacityForm({
  onEdit,
  venueDefaultDatas,
  forceEdit,
  onClose,
}: {
  onEdit(venueDatas: VenuePreset): void;
  venueDefaultDatas: VenuePreset;
  forceEdit?: boolean;
  onClose?: () => void;
}) {
  const { panelOpen } = useContext(DefaultDatasContext);
  const [isEditing, setIsEditing] = useState(forceEdit ? true : false);

  const disableSubmitActions = false; //TODO

  const handleEdit = (avgCapacity: number) => {
    onEdit({ ...venueDefaultDatas, avgCapacity });
    if (!forceEdit) setIsEditing(false);
  };

  const handleRemoveClick = () => {
    if (onClose) onClose();
    else setIsEditing(false);
  };

  return (
    <div id="average-gauge-form">
      {(isEditing && !!panelOpen) || !!forceEdit ? (
        <QuizEdition
          removeFromEditing={handleRemoveClick}
          title={translate(
            `ProjectsVenue.DefaultDatas.Public.Forms.AverageGauge.what-average-gauge`,
          )}
          form={
            <Form
              onSubmit={(values) => handleEdit(values)}
              defaultValue={venueDefaultDatas?.avgCapacity}
              disableSubmit={disableSubmitActions}
            />
          }
        />
      ) : (
        <QuizNotEdition
          addToEditing={() => setIsEditing(true)}
          answeredValues={[
            `${venueDefaultDatas?.avgCapacity}  ${translate(
              venueDefaultDatas?.avgCapacity &&
                venueDefaultDatas?.avgCapacity > 1
                ? 'ImpactQuestion.ACCOMMODATION_PUBLIC.people'
                : 'ImpactQuestion.ACCOMMODATION_PUBLIC.person',
            )}`,
          ]}
          title={translate(
            `ProjectsVenue.DefaultDatas.Public.Forms.AverageGauge.what-average-gauge`,
          )}
          isAnswered={
            venueDefaultDatas?.avgCapacity !== undefined &&
            venueDefaultDatas?.avgCapacity > 0
          }
        />
      )}
    </div>
  );
}

function Form({
  onSubmit,
  defaultValue,
  disableSubmit,
}: {
  onSubmit: (avgCapacity: number) => void;
  defaultValue?: number;
  disableSubmit: boolean;
}) {
  const { handleSubmit, register, formState } = useForm<{
    avgCapacity: number;
  }>({
    defaultValues: { avgCapacity: defaultValue || 0 },
  });

  const { errors } = formState;

  const handleFormSubmit = (data: { avgCapacity: number }) => {
    onSubmit(parseInt(data.avgCapacity.toString()));
  };

  return (
    <Stack>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Stack>
          <FSTextField
            type="number"
            label={translate(
              `ProjectsVenue.DefaultDatas.Public.Forms.AverageGauge.average-gauge`,
            )}
            register={{
              ...register('avgCapacity', {
                required: translate('Form.fill-the-field'),
                validate: isNumber,
              }),
            }}
            error={!!errors.avgCapacity}
            helperText={errors.avgCapacity?.message}
          />

          <Box marginTop={1}>
            <FSPrimaryButton type="submit" disabled={disableSubmit}>
              {translate('Form.save')}
            </FSPrimaryButton>
          </Box>
        </Stack>
      </form>
    </Stack>
  );
}
